import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { ExpandMore, KeyboardArrowRight } from "@mui/icons-material";
import { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import baseURL from "../../../../configs/api";
import ReactQuill from "react-quill";
import { validateMin } from "../../../../utils/validateMin";
import { useTheme } from "../../../../components/hooks/useTheme";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import colorConfigs from "../../../../configs/colorConfigs";
import useAuth from "../../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";

export const GeneralSettings = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
      ["link", "image", "video"],
      ["clean"],
    ],
  };
  const { auth }: any = useAuth();
  const { themeStyles, theme } = useTheme();
  const { handleTenantError }: any = useTenant();
  const [isGeneralSettings, setIsGeneralSetttings] = useState<boolean>(true);
  const [isMaintenanceAlerts, setIsMaintenanceAlerts] = useState<boolean>(true);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [id, setId] = useState<number>(0);
  const [
    enableRepairOrderWhenVehicleIsOnRent,
    setEnableRepairOrderWhenVehicleIsOnRent,
  ] = useState<string>("No");
  const [amountOfPartsIsMandatory, setAmountOfPartsIsMandatory] = useState<string>("No");
  const [useAmountsInRepairOrders, setUseAmountsInRepairOrders] = useState<string>("No");
  const [amountOfLaborIsMandatory, setAmountOfLaborIsMandatory] = useState<string>("No");
  const [notesIsMandatory, setNotesIsMandatory] = useState<string>("No");
  const [enablePickupAndReturnLocations, setEnablePickupAndReturnLocations] = useState<string>("No");
  const [defaultStatusId, setDefaultStatusId] = useState<string>("");
  const [disableVehicleMaintenance, setDisableVehicleMaintenance] = useState<string>("No");
  const [userToNotify, setUserToNotify] = useState<any>();
  const [sendMaintenanceAlertsEveryXDays, setSendMaintenanceAlertsEveryXDays] =
    useState<string>("");
  const [emailSubject, setEmailSubject] = useState<string>("");
  const [emailContent, setEmailContent] = useState<any>();
  const [defaultStatusOptions, setDefaultStatusOptions] = useState([]);
  const [userToNotifyOptions, setUserToNotifyOptions] = useState<any[]>([]);
  const [userToNotifyArray, setUserToNotifyArrray] = useState<any[]>([]);
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
  const [maintenanceStatusIsLoaded, setMaintenanceStatusIsLoaded] =
    useState<boolean>(false);
  const [usersDataIsLoaded, setUsersDataIsLoaded] = useState<boolean>(false);

  useEffect(() => {
    setPleaseWaitPopup(true);
    axios
      .get(`${baseURL}maintenanceStatus`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setDefaultStatusOptions(() =>
          response.data.map((item: any) => {
            return { value: item.id, label: item.name };
          })
        );

        setMaintenanceStatusIsLoaded(true);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);       
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axios
      .get(`${baseURL}users`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setUserToNotifyOptions(() =>
          response.data.map((item: any) => {
            return {
              value: item.id,
              label: item.firstName + " " + item.lastName,
            };
          })
        );

        setUsersDataIsLoaded(true);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);       
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (maintenanceStatusIsLoaded && usersDataIsLoaded)
      axios
        .get(`${baseURL}maintenanceGeneralSetting`, {
          headers: {
            'X-Tenant-ID': tenantId,
          }
        })
        .then((response) => {
          setId(response?.data?.id);
          setEnableRepairOrderWhenVehicleIsOnRent(
            response.data.enableRepairOrderWhenVehicleIsOnRent ? "Yes" : "No"
          );
          setAmountOfPartsIsMandatory(response.data.amountOfPartsIsMandatory ? "Yes" : "No");
          setUseAmountsInRepairOrders(response.data.useAmountsInRepairOrders ? "Yes" : "No");
          setAmountOfLaborIsMandatory(response.data.amountOfLaborIsMandatory ? "Yes" : "No");
          setNotesIsMandatory(response.data.notesIsMandatory ? "Yes" : "No");
          setEnablePickupAndReturnLocations(
            response.data.enablePickupAndReturnLocations ? "Yes" : "No"
          );
          setDefaultStatusId(response.data.maintenanceStatusId);
          setDisableVehicleMaintenance(response.data.disableVehicleMaintenance ? "Yes" : "No");
          setSendMaintenanceAlertsEveryXDays(
            response.data.sendMaintenanceAlertsEveryXDays
          );
          setEmailSubject(response.data.emailSubject);
          setEmailContent(response.data.emailContent);
          const notifyArray = response?.data?.usersToNotifyForMaintenanceAlerts?.split(",");

          setUserToNotifyArrray(
            userToNotifyOptions?.filter((item: any) =>
              notifyArray?.some((data: string) => item?.value === parseInt(data))
            )
          );
          setUserToNotify(
            userToNotifyOptions?.filter((item: any) =>
              notifyArray?.some((data: string) => item?.value === parseInt(data))
            )
          );

          setMaintenanceStatusIsLoaded(false);
          setUsersDataIsLoaded(false);
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);           
        });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maintenanceStatusIsLoaded, usersDataIsLoaded]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setPleaseWaitPopup(true);

    await axios
      .put(
        `${baseURL}maintenanceGeneralSetting?userId=${auth?.id}`,
        JSON.stringify({
          id: id,
          enableRepairOrderWhenVehicleIsOnRent: enableRepairOrderWhenVehicleIsOnRent === "Yes",
          amountOfPartsIsMandatory: amountOfPartsIsMandatory === "Yes",
          notesIsMandatory: notesIsMandatory === "Yes",
          useAmountsInRepairOrders: useAmountsInRepairOrders === "Yes",
          amountOfLaborIsMandatory: amountOfLaborIsMandatory === "Yes",
          enablePickupAndReturnLocations: enablePickupAndReturnLocations === "Yes",
          maintenanceStatusId: defaultStatusId,
          disableVehicleMaintenance: disableVehicleMaintenance === "Yes",
          usersToNotifyForMaintenanceAlerts: userToNotifyArray
            ?.map((item) => item.value)
            .join(","),
          sendMaintenanceAlertsEveryXDays,
          emailSubject,
          emailContent,
        }),
        {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
          },
          withCredentials: true,
        }
      )
      .then(() => {
        setPleaseWaitPopup(false);
        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWaitPopup(false);
        handleTenantError(error);       
      });
  };

  useEffect(() => {
    if (userToNotify) {
      const arrray = [];
      for (let i = 0; i < userToNotify.length; i++) {
        arrray.push(userToNotify[i]);
      }

      setUserToNotifyArrray(arrray);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userToNotify]);

  return (
    <>
      <div className={`px-[20px] py-[16px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[7px] flex flex-col`}>
          <div className="w-full">
            <div className={`w-full`}>
              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center">
                </div>

                {
                  disabled && (
                    <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                      onClick={() => setDisabled(false)}
                    >
                      <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                        edit
                      </span>
                      <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                    </button>
                  )
                }
              </div>

              <div className="p-2">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <h5
                    className="mb-0 flex items-center cursor-pointer select-none"
                    onClick={() => setIsGeneralSetttings(!isGeneralSettings)}
                  >
                    {isGeneralSettings ? (
                      <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                    ) : (
                      <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                    )}
                    <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                      General Settings
                    </div>
                  </h5>
                  <hr />

                  {isGeneralSettings &&
                    <div className="w-full px-2 pt-4">
                      <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Enable Repair Order When Vehicle is on Rent</label>
                            <RadioGroup
                              row
                              value={enableRepairOrderWhenVehicleIsOnRent}
                              onChange={(e) => setEnableRepairOrderWhenVehicleIsOnRent(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="Yes"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="No"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Amount of Parts is Mandatory?</label>
                            <RadioGroup
                              row
                              value={amountOfPartsIsMandatory}
                              onChange={(e) => setAmountOfPartsIsMandatory(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="Yes"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="No"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Notes is Mandatory?</label>
                            <RadioGroup
                              row
                              value={notesIsMandatory}
                              onChange={(e) => setNotesIsMandatory(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="Yes"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="No"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Disable Vehicle Maintenance</label>
                            <RadioGroup
                              row
                              value={disableVehicleMaintenance}
                              onChange={(e) => setDisableVehicleMaintenance(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="Yes"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="No"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                            </RadioGroup>
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Use Amounts in Repair Orders</label>
                            <RadioGroup
                              row
                              value={useAmountsInRepairOrders}
                              onChange={(e) => setUseAmountsInRepairOrders(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="Yes"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="No"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Amount of Labor is Mandatory?</label>
                            <RadioGroup
                              row
                              value={amountOfLaborIsMandatory}
                              onChange={(e) => setAmountOfLaborIsMandatory(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="Yes"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="No"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Enable Pickup and Return Locations</label>
                            <RadioGroup
                              row
                              value={enablePickupAndReturnLocations}
                              onChange={(e) => setEnablePickupAndReturnLocations(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="Yes"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="No"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Default Status</label>
                            <Select
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                  borderRadius: '8px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                  "&: hover": {
                                    borderColor: "#167AC3",
                                  }

                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "12px",
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                }),
                                option: (base, state) => {
                                  const isSelected = state.isSelected;
                                  const isFocused = state.isFocused;
                                  const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                  const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                  const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                  return {
                                    ...base,
                                    backgroundColor: isSelected
                                      ? selectedBg
                                      : isFocused
                                        ? hoverBg
                                        : "transparent",
                                    color: isSelected ? "#fff" : defaultTextColor,
                                    fontWeight: 600,
                                    ':active': {
                                      backgroundColor: isSelected ? selectedBg : hoverBg,
                                    },
                                  };
                                },
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={disabled}
                              isLoading={false}
                              isClearable={false}
                              isRtl={false}
                              isSearchable={false}
                              name="defaultStatus"
                              value={defaultStatusOptions.find(
                                (item: any) => item.value === defaultStatusId
                              )}
                              onChange={(itemType: any) =>
                                setDefaultStatusId(itemType ? itemType.value : "")
                              }
                              options={defaultStatusOptions}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  }

                  <h5
                    className="mb-0 flex items-center cursor-pointer select-none"
                    onClick={() => setIsMaintenanceAlerts(!isMaintenanceAlerts)}
                  >
                    {isMaintenanceAlerts ? (
                      <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                    ) : (
                      <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                    )}
                    <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                      Maintenance Alerts
                    </div>
                  </h5>
                  <hr />

                  {isMaintenanceAlerts &&
                    <div className="w-full px-2 pt-4">
                      <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Users To Notify For Maintenance Alerts</label>
                            <Select
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                  borderRadius: '8px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                  "&: hover": {
                                    borderColor: "#167AC3",
                                  }

                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "12px",
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                }),
                                option: (base, state) => {
                                  const isSelected = state.isSelected;
                                  const isFocused = state.isFocused;
                                  const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                  const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                  const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                  return {
                                    ...base,
                                    backgroundColor: isSelected
                                      ? selectedBg
                                      : isFocused
                                        ? hoverBg
                                        : "transparent",
                                    color: isSelected ? "#fff" : defaultTextColor,
                                    fontWeight: 600,
                                    ':active': {
                                      backgroundColor: isSelected ? selectedBg : hoverBg,
                                    },
                                  };
                                },
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,
                                }),
                              }}
                              isMulti
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={disabled}
                              isLoading={false}
                              isClearable={false}
                              isRtl={false}
                              isSearchable={false}
                              name="usersToNotifyForMaintenanceAlerts"
                              value={userToNotify}
                              onChange={(value) => setUserToNotify(value)}
                              options={userToNotifyOptions}
                              required
                            />
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Send Maintenance Alerts Every X Days</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={sendMaintenanceAlertsEveryXDays}
                              onChange={(e) =>
                                setSendMaintenanceAlertsEveryXDays(validateMin(e.target.value, 0).toString())
                              }
                              disabled={disabled}
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div className="mt-2">
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Email Subject</label>
                        <input
                          type="text"
                          className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={emailSubject}
                          onChange={(e) => setEmailSubject(e.target.value)}
                          disabled={disabled}
                          required
                        />
                      </div>

                      <div
                        className="quill-wrapper my-2"
                        style={{
                          ...(theme === 'dark' && {
                            '--quill-text-color': '#ffffff',
                            '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                          }),
                        } as React.CSSProperties}
                      >

                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Email Content</label>
                        <ReactQuill
                          className="custom-quill"
                          style={{ height: "200px" }}
                          theme="snow"
                          modules={modules}
                          value={emailContent}
                          onChange={setEmailContent}
                          readOnly={disabled}
                        />
                      </div>
                    </div>
                  }

                  {
                    !disabled && (
                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.main.bg,
                          marginTop: "80px"
                        }}
                        type="submit"
                      >
                        Save
                      </Button>
                    )
                  }
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  );
};
